import messages from './messages';

const useUpdateQuotation = () => {
  return {
    updateQuotationErrorMessages: messages,
  };
};

export default useUpdateQuotation;
